import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { translations, utils } from 'gipsy-misc'
import { styles } from 'gipsy-misc'

const propTypes = {
  group: PropTypes.string,
  totalDuration: PropTypes.number,
  onClick: PropTypes.func,
  text: PropTypes.string
}

const Header = styled.div`
  overflow: hidden;
  border-bottom: 2px solid ${styles.colors.borderColor};
  margin-bottom: 20px;
  h3 {
    display: inline-block;
    vertical-align: middle;
    width: auto !important;
  }
  .duration {
    line-height: 24px;
  }
  .pointer {
    cursor: pointer;
  }
  &::after {
    content: '';
    clear: both;
  }
`

class ArchiveListHeader extends PureComponent {
  render() {
    const { group, totalDuration, onClick, text } = this.props

    return (
      <Header>
        <h3>{utils.datetime.humanizeDate(group) || utils.string.capitalize(translations.general[group] || group)}</h3>
        {typeof totalDuration === 'undefined' ? (
          onClick && (
            <div className="float-right pointer" onClick={onClick}>
              {text}
            </div>
          )
        ) : (
          <div className="duration float-right">{utils.datetime.beautifyDuration(totalDuration)}</div>
        )}
      </Header>
    )
  }
}

ArchiveListHeader.propTypes = propTypes

export default ArchiveListHeader



// WEBPACK FOOTER //
// ./src/features/list/components/archiveListHeader/index.js